import {connect} from 'react-redux';
import Navigation from "../ui/Navigation";
import C, {RequestTypes} from '../../constants';
import {recordTestResults} from "../../store/actions";

const mapStateToProps = state => {
    let question = state.questions.find(q => q.id === state.testData.currentQId);
    let unanswered = state.questions.find(q => -1 === Number.parseInt(q.result));
    return {
        testData: state.testData,
        currentResult: Number.parseInt(question.result),
        isAllQuestionsAnswered: unanswered === undefined,
        request: {
            type: RequestTypes.RECORD_QUESTIONS,
            updateRecordId: state.awsTestRecordId,
            session: state.session,
            questions: state.questions
        },
        isLoading: state.isProcessing
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setCurrentQuestion(qId) {
            dispatch({
                type: C.SET_CURRENT_QUESTION,
                payload: qId
            })
        },
        submitResults(req) {
            dispatch(
                recordTestResults(req)
            )
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)
